// Import necessary React hooks
import { useState } from "react";
// Import necessary Material-UI components
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
// Import custom components and hooks
import { DataGridTable } from "../../common";

import {
  EditDeleteItemSampleRequestModal,
  AddItemSampleRequestModal,
  AddItemsInBulkSampleRequestModal,
} from "./editRequestBeforeSubmit";
import { useNewRequest, useNewRequestContext } from "../hooks";

export function ItemList() {
  // Hook to set the item to be edited
  const { setItemFormToEdit } = useNewRequest();
  // Hook to access the current state of the new request
  const { state } = useNewRequestContext();
  // State to control the visibility of the EditDeleteItemSampleRequestModal
  const [openEditItemSampleRequestModal, setOpenEditItemSampleRequestModal] =
    useState(false);
  // Function to open the EditDeleteItemSampleRequestModal and set the item to be edited
  const handleOpenEditItemSampleRequestModal = (data) => {
    setItemFormToEdit(data);
    setOpenEditItemSampleRequestModal(true);
  };
  // State to control the visibility of the AddItemSampleRequestModal
  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  // Function to open the AddItemSampleRequestModal
  const handleOpenAddItemModal = () => setOpenAddItemModal(true);
  // State to control the visibility of the AddItemInBulkSampleRequestModal
  const [openAddItemsInBulkModal, setOpenAddItemsInBulkModal] = useState(false);
  // Function to open the AddItemInBulkSampleRequestModal
  const handleOpenAddItemsInBulkModal = () => setOpenAddItemsInBulkModal(true);
  // Retrieve the items from the sample request details
  let data = state.sampleRequestDetails.items;

  // Add a custom property to each item for displaying edit or delete options
  data &&
    data.forEach((item, i) => {
      item.editOrDeleteItem = "Edit Or Delete";
    });
  // Determine the title and description based on the number of items
  const title = data.length < 1 ? "Add Item" : "All Items";
  const description =
    data.length < 1
      ? "Please add atleast one item to be able to submit a new sample request"
      : "Click on a row to edit the corresponding item";
  // Function to handle row clicks, setting the item to be edited and opening the modal
  function handleRowClick(event) {
    setItemFormToEdit({ ...event.row, rowId: event.row.id });
    handleOpenEditItemSampleRequestModal(event.row);
  }

  return (
    <div>
      {/*  Render the DataGridTable component with the items, title, description, and row click handler */}
      <DataGridTable
        title={title}
        description={description}
        data={data}
        handleRowClick={handleRowClick}
        loading={data.length < 1 ? false : true}
        button={
          <Grid item>
            {/*  Render a button for adding a new item */}
            <Button
              size="small"
              variant="contained"
              sx={{
                padding: "10px 20px",
                mr: "20px",
                fontSize: "14px",
                backgroundColor: "#c7ab79",
                "&:hover": {
                  backgroundColor: "#c4943f",
                },
                textTransform: "capitalize",
              }}
              onClick={handleOpenAddItemModal}
            >
              Add Item
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{
                padding: "10px 20px",
                mr: "20px",
                fontSize: "14px",
                backgroundColor: "#c7ab79",
                "&:hover": {
                  backgroundColor: "#c4943f",
                },
                textTransform: "capitalize",
              }}
              onClick={handleOpenAddItemsInBulkModal}
            >
              Add Items in bulk
            </Button>
          </Grid>
        }
      />
      {/*  Conditionally render the EditDeleteItemSampleRequestModal if an item is selected for editing */}
      {state?.itemFormToEdit && (
        <EditDeleteItemSampleRequestModal
          open={openEditItemSampleRequestModal}
          setOpen={setOpenEditItemSampleRequestModal}
          handleOpen={handleOpenEditItemSampleRequestModal}
          data={state.itemFormToEdit}
        />
      )}
      {/* Render the AddItemSampleRequestModal for adding new items */}
      <AddItemSampleRequestModal
        open={openAddItemModal}
        setOpen={setOpenAddItemModal}
        handleOpen={handleOpenAddItemModal}
      />
      {/* Render the AddItemsInBulkSampleRequestModal for adding new items */}
      <AddItemsInBulkSampleRequestModal
        open={openAddItemsInBulkModal}
        setOpen={setOpenAddItemsInBulkModal}
        handleOpen={handleOpenAddItemsInBulkModal}
      />
    </div>
  );
}
